module.exports = __webpack_public_path__ + "img/information-trust-widget.c59f42cf.png";